import { ele } from "cables-shared-client";
import web from "./index.js";

export default class Tables
{
    init()
    {
        const tables = ele.byQueryAll("table.sortable");
        this.initTables(tables);
    }

    initTables(tables)
    {
        let sortBy = "";
        let sortAsc = true;
        tables.forEach((table) =>
        {
            let rows = table.querySelectorAll("tr:nth-child(n+2)");
            const headings = table.querySelectorAll("th");
            headings.forEach((heading, i) =>
            {
                heading.addEventListener("click", () =>
                {
                    const by = heading.innerText;
                    if (sortBy === by) sortAsc = !sortAsc;
                    sortBy = by;
                    [...rows].sort((a, b) =>
                    {
                        const num = i + 1;
                        const selector = "td:nth-child(" + num + ")";
                        const tdLeft = a.querySelector(selector);
                        const tdRight = b.querySelector(selector);
                        const t1 = tdLeft ? tdLeft.innerText : "z";
                        const t2 = tdRight ? tdRight.innerText : "a";
                        if (sortAsc) return t1.localeCompare(t2);
                        return t2.localeCompare(t1);
                    }).forEach((node) => { return table.appendChild(node); });
                });
            });
        });
    }
}
